export default __webpack_public_path__ + "static/media/web.87c5d992.svg";